import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import {  SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.less']
})
export class InfoComponent implements OnInit, OnDestroy{

  textAbout:SafeHtml;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService
  ) {
  }


  ngOnInit() {

    this.informationService.getFrontParams().pipe(
      takeUntil(this.destroySubject),
    )
      .subscribe(
      (res: any) => {
        let textAboutHtml = res.results.find ((value:any) =>  value.name == 'text-about')?.value;
        this.textAbout = this.informationService.getSanitizeString(textAboutHtml);

    })

  }

  ngOnDestroy() {
    this.destroySubject.next();
  }

}




